export default (theme) => ({
    'blockquote': {
        fontStyle: 'italic',
        borderLeft: `4px solid ${theme.colorSchemes.light.palette.primary[500]}`,
        margin: theme.spacing(2),
        padding: theme.spacing(0, 2),
    },
});
